import { createElement } from 'react';
import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import SecurityIcon from '@material-ui/icons/Security';
import { RbacClient, rbacApiRef } from './api';

const rbacApi = ApiBlueprint.make({
  name: 'rbac',
  params: defineApi =>
    defineApi({
      api: rbacApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new RbacClient(discoveryApi, fetchApi),
    }),
});

const rbacPage = PageBlueprint.make({
  name: 'root',
  params: {
    path: '/rbac',
    title: 'RBAC',
    icon: createElement(SecurityIcon),
    loader: () =>
      import('./components/RbacPage').then(m => createElement(m.RbacPage)),
  },
});

const rbacEntityContent = EntityContentBlueprint.make({
  name: 'rbac-details',
  params: {
    path: '/rbac',
    title: 'RBAC',
    filter: entity =>
      entity.apiVersion === 'rbac.backstage.io/v1alpha1' &&
      ['RbacPolicy', 'RbacRole', 'RbacRoleBinding'].includes(entity.kind),
    loader: () =>
      import('./components/RbacEntityDetailsPage').then(m =>
        createElement(m.RbacEntityDetailsPage),
      ),
  },
});

export const rbacPlugin = createFrontendPlugin({
  pluginId: 'rbac',
  extensions: [rbacApi, rbacEntityContent, rbacPage],
});
